import loading from './loading'
import service from './service'
import msgToUser from './msgToUser'
import guestPayment from './guestPayment'
import language from './language'
import browserToken from './browserToken'

const reducers = {
  loading,
  service,
  msgToUser,
  guestPayment,
  language,
  browserToken,
}

export default reducers
